export const numberToPercentString = (num: number) => `${num}%`;